import PropTypes from 'prop-types';
import React from 'react';

import GroupLink from '../group_link';
import Link from '../link';

const Btn = ({
	children,
	className = '',
	color = 'primary',
	component = 'link',
	excerpt,
	fixedWidth = false,
	footnote,
	fullWidth = false,
	icon,
	labelType = 'span',
	leftSection,
	removePill = false,
	rightSection,
	size = 'md',
	variant = 'fill',
	withIcon = false,
	withShadow = false,
	withThumb = false,
	...props
}) => {
	const colors = {
		accent: 'accent',
		danger: 'danger',
		dark: 'dark',
		light: 'light',
		primary: 'primary',
		primary_light: ' bg-primary-light',
		white: 'light',
	};

	const variants = {
		cta: { class: 'btn-', extras: '' },
		fill: { class: 'btn-', extras: '' },
		link: { class: 'btn-link ', extras: 'px-0 text-decoration-none' },
		outlined: { class: 'btn-outline-', extras: '' },
		thumb_btn: { class: 'btn-', extras: 'text-start ' },
	};

	const sizes = {
		lg: {
			btn: 'btn-lg',
			icon: 'lg',
			label: 'base',
		},
		md: {
			btn: '',
			icon: 'md',
			label: 'sm',
		},
		sm: {
			btn: 'btn-sm',
			icon: 'md',
			label: 'sm',
		},
		title_small: {
			btn: '',
			icon: 'sm',
			label: 'title-small mb-0',
		},
		xs: {
			btn: 'btn-sm',
			icon: 'md',
			label: 'xs',
		},
	};

	const components = {
		button: {
			Component: 'button',
		},
		div: {
			Component: 'div',
		},
		group_link: {
			Component: GroupLink,
		},
		link: {
			Component: Link,
		},
	};

	const Component = components[component]?.Component;
	const LabelComponent = labelType;

	return (
		<>
			<Component
				className={`btn ${removePill ? 'rounded-1' : 'rounded-pill'}  ${
					withThumb && 'btn-thumb'
				} ${withShadow && 'shadow-sm'}  ${variants[variant]?.class}${
					colors[color]
				} ${variants[variant]?.extras}  ${sizes[size].btn}  ${
					fullWidth ? 'w-100' : 'fit-content'
				} ${fixedWidth && 'btn-fixed-width-md'} ${
					withIcon && 'py-1 px-0 pe-2 ps-4'
				} ${sizes[size] == 'lg' && (!rightSection || !leftSection) && 'px-5'} ${
					!withThumb && (rightSection || leftSection) && 'px-4'
				} ${className}`}
				{...props}
			>
				<span
					className={`${
						(withIcon || leftSection || rightSection) &&
						'd-flex align-items-center justify-content-between'
					}`}
				>
					{leftSection && <div className="me-2">{leftSection}</div>}
					<span className={`${withThumb && 'me-auto ms-2'}`}>
						<LabelComponent
							className={`mb-0 ${sizes[size].label} ${
								withIcon && !variant == 'title_small' && 'me-5'
							}`}
						>
							{children}
						</LabelComponent>
						{footnote && <div className={`text-muted xs`}>{footnote}</div>}
					</span>
					{rightSection ||
						(withIcon && (
							<>
								{rightSection}
								<div
									className={`ms-2 btn-icon ${
										variant == 'link' &&
										`icon-circle icon-container-${sizes[size].icon}`
									} icon-${sizes[size].icon}`}
								>
									{icon}
								</div>
							</>
						))}
				</span>
				{excerpt && (
					<div className="d-block">
						<hr />
						<p className={`text-muted fw-500 xs mt-2`}>{excerpt}</p>
					</div>
				)}
			</Component>
		</>
	);
};

Btn.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object,
		PropTypes.string,
	]),
	className: PropTypes.string,
	color: PropTypes.string,
	component: PropTypes.string,
	excerpt: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	fixedWidth: PropTypes.bool,
	footnote: PropTypes.string,
	fullWidth: PropTypes.bool,
	icon: PropTypes.string,
	labelSize: PropTypes.string,
	labelType: PropTypes.string,
	leftSection: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	removePill: PropTypes.bool,
	rightSection: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	size: PropTypes.string,
	variant: PropTypes.string,
	withIcon: PropTypes.bool,
	withShadow: PropTypes.bool,
	withThumb: PropTypes.bool,
};

export default Btn;
